import VueI8n from '@/i18n/locale'
import ruleConfig from './rules-CR'

export default {
  ...ruleConfig,
  multiplePhones (mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      rules: {
        custom: value => (value && max ? value.split(',').length <= max : true),
        pattern: /^\d{8,9}$/
      },
      messages: {
        custom: max ? `${mask}${sprintf(gettext('最多%d个'), max)}` : '',
        pattern: VueI8n.t('FoodB_Launch_Illegal_import_jlOS' /** 输入非法 */)
      }
    }
  }
}
